import { capitalize, styled } from "@mui/material";
import { actionHeaderClasses, actionHeaderName } from "../classes.js";
const Root = styled("div", {
  name: actionHeaderName,
  slot: "Root",
  shouldForwardProp: (prop) => prop !== "ownerState" && prop !== "padded",
  overridesResolver: (props, styles) => {
    const { ownerState } = props;
    return [
      styles.root,
      ownerState?.expanded && styles.expanded,
      ownerState?.size && styles[`size${capitalize(ownerState.size)}`],
      (ownerState?.expanded || ownerState?.padded) && styles.padded,
      ownerState?.hideIcon && "hideIcon"
    ];
  }
})(({ theme, ownerState }) => {
  const hoverPimary = `&:hover > .${actionHeaderClasses.primaryActionHover}`;
  const hoverSecondary = `&:hover > .${actionHeaderClasses.secondaryActionHover}`;
  const hover = `${hoverPimary}, ${hoverSecondary}`;
  return {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    flexDirection: "row",
    overflow: "hidden",
    ...ownerState?.size === "tiny" && {
      fontSize: theme.typography.fontSize - 2
    },
    ...ownerState?.size === "small" && {
      fontSize: theme.typography.fontSize - 1
    },
    ...ownerState?.size === "medium" && {
      fontSize: theme.typography.fontSize
    },
    ...ownerState?.size === "large" && {
      fontSize: theme.typography.fontSize + 2
    },
    ...(ownerState?.padded || ownerState?.expanded) && {
      paddingBottom: theme.spacing(2)
    },
    [hover]: {
      display: "block"
    }
  };
});
export {
  Root
};
//# sourceMappingURL=Root.js.map
